import {apiFetch} from "./client";

export interface MerchantPortalInQuoteBody {
  clientRequestId: string;
  /** Копейки. С `amountMin` — верхняя граница диапазона. */
  amount: number;
  bank: "any" | "sber" | "tinkoff" | "sbp";
  /** Копейки, нижняя граница диапазона. Нет поля — точная сумма. */
  amountMin?: number;
  /** Сколько переводов, 2..20. Нет поля — как раньше. */
  transferCount?: number;
  /** Копейки, минимум одного перевода; задаётся вместе с `transferCount`. */
  minTransferAmount?: number;
}

export interface MerchantPortalInQuote {
  quoteId: string;
  fiatAmount: number;
  rate: string;
  usdtAtomic: string;
  quotedAt: string;
  expiresAt: string;
  /** Только у диапазона: нижняя граница в копейках и USDT по ней (`usdtAtomic` — по верхней). */
  amountMin?: number;
  usdtAtomicMin?: string;
  transferCount?: number;
  minTransferAmount?: number;
}

export function quoteMerchantPortalIn(token: string | null, body: MerchantPortalInQuoteBody): Promise<MerchantPortalInQuote> {
  return apiFetch<MerchantPortalInQuote>("/merchant/me/orders/quote", token, {
    method: "POST", body: JSON.stringify(body),
  });
}

export function createMerchantPortalIn(token: string | null, body: MerchantPortalInQuoteBody & {quoteId: string}): Promise<{orderId: string}> {
  return apiFetch<{orderId: string}>("/merchant/me/orders", token, {
    method: "POST", body: JSON.stringify({...body, side: "in"}),
  });
}
